export default __webpack_public_path__ + "static/media/playIcon.a73156c1.svg";